/* eslint-disable */
import {gsap} from "gsap";

window.addEventListener('load', () => {
  ServicesBlock.init();
});

const ServicesBlock = {
  init: function () {
    const sections = document.querySelectorAll('[data-services-block-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.initSection(section)
    })

  },

  initSection: function (section) {
    let deco = section.querySelector('[data-deco-js]');
    let trigger = section.querySelector('[data-deco-trigger-js]');
    if(!deco || !trigger) return;

    let anim_1 = gsap.fromTo(
      deco,
      {
        height: '0px',
      },
      {
        height: '100%',
        ease: 'none',
        immediateRender: false,
        scrollTrigger: {
          trigger: trigger,
          start: 'top+=250 bottom',
          end: 'bottom+=250 bottom',
          scrub: 1,
          // markers: true,
          invalidateOnRefresh: true,
        },
      }
    );
  },

}

export default ServicesBlock;
